import React from 'react';
import TableCasino from '../../../../@casino/ui/table';
import Title from '../../../../@casino/ui/title';
import {getDate} from '../../../../@casino/lib/getDate';
import { useDispatch, useSelector } from 'react-redux';
import { setGetSupportList } from '../store/thunk/setGetSupportList';
import { setPostSupportUpdateStatus } from '../store/thunk/setPostSupportUpdateStatus';
import DialogView from '../components/dialog_view';
import { setGetSupportView } from '../store/thunk/setGetSupportView';

const SupportList = () => {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = React.useState(false);

    React.useEffect(() => {
        dispatch(setGetSupportList());
    }, [])

    const columns = [
        { id: 'id', label: 'ID'},
        { id: 'date', label: 'Дата обращения'},
        { id: 'name', label: 'Имя'},
        { id: 'email', label: 'E-mail'},
        { id: 'message', label: 'Сообщение'},
        { id: 'status', label: 'Статус'},
    ];
    
    const getRows = (value) => {
        return value.map((item) => {
            return {
                id: item.id,
                date: getDate(item.data),
                name: item.label_name,
                email: item.email,
                message: item.message,
                status: item.status ? 'Не прочитано' : 'Прочитано'
            }
        })
    } 

    const support_list = useSelector(state => state.support.list);
    const view = useSelector(state => state.support.view);
    const rows = getRows(support_list);

    return (
        <div style={{padding: 20, paddingTop: 0}}>
            <Title label="Техническая поддержка"/>
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
                marginBottom: 12,
            }}>
                <TableCasino
                    changeStatus={(id) => {
                        dispatch(setPostSupportUpdateStatus({
                            id
                        }))
                        dispatch(setGetSupportView({
                            id
                        }, setShowModal))
                        
                    }}
                    columns={columns}
                    rows={rows}
                /> 
            </div>
            <DialogView setShowModal={setShowModal} showModal={showModal} view={view} close={() => dispatch(setGetSupportList())} />
        </div>
    )
}

export default SupportList;